// 英语(English)
export default {
  oneOneClass: "1-on-1 {course} Class",
  learnPracEnFast: "Learn practical {language} fast!",
  htOralClass: "HelloTalk Oral Class",
  benefits: "4 benefits",
  topicNumber: "800+ interactive topics",
  dailyBusinessAcademic:
    "Everyday, Business and Academic English, plus {test name}",
  englishTutors: "TEFL/TESOL qualified teachers",
  qualifiedTutors: "Qualified native-speaking teachers",
  nativeOkAllAges:
    "Our {course} native-speaking teachers are experienced with all ages",
  oneOneLive: "1-on-1 live lessons",
  accessToRecord: "Ongoing access to your lesson recordings",
  personalizedPlan: "Personalized study plan",
  ensureGoal: "Our teachers are here to ensure you smash your goals",
  professional: "Professional",
  nativeTeam: "Native-speaking team",
  authenticLanguage: "Offering lessons in authentic {language} ",
  bgChecked: "Background-checked team",
  experiencedTeachers:
    "Experienced instructors guide you through every step of the journey",
  assuredQuality: "Quality assured",
  regularAssess:
    "All teachers are regularly assessed, ensuring a first-rate service",
  assuredSatisfaction: "Satisfaction guaranteed",
  teamSizeAndRefund:
    "With 2k+ teachers to choose from, we’ll even refund your balance if you’re not completely satisfied",
  curriculum: "Curriculum",
  dailyTalks: "Daily conversations",
  beginnerInfo: "Beginners' lessons - 40 lessons",
  lessonOverview: "Lesson overview",
  beginnerClassIntro:
    "Scientifically-designed sections include role-play and contextual learning. Real-life scenarios are created to ensure you master practical, authentic expressions.",
  topicEx: "Topic example",
  beginnerTopicEx: "Self-introduction, Dining & Ordering, Hobbies",
  mediateInfo: "Intermediate - 80 lessons",
  mediateClassIntro:
    "Over 80 of the most common topics covered, enabling you to articulate opinions after the session.",
  mediateTopicEx:
    "Asking and Giving Directions, Seeing a Doctor, Expressing Views",
  advancedInfo: "Advanced - 80 Lessons",
  advancedClassIntro:
    "By generating discussion on current affairs, you will be able to share your thoughts and express your views.",
  advancedTopicEx:
    "Renting and Buying a House, Invitations and Parties, Travel",
  businessLanguage: "Business {language}",
  busElementInfo: "Elementary level - 40 lessons",
  busElementClassIntro:
    "This will help you develop practical business language skills for today's commercial world. Whether you need business {language} for the workplace or further afield, this is the course for you.",
  busElementTopicEx:
    "Preparing your Resume, Applications and Interviews, Starting your Career",
  busMediateInfo: "Intermediate - 40 lessons",
  busMediateClassIntro:
    "Develop your Business {language} skills through real-life scenarios.",
  busMediateTopicEx: "Contracts, Negotiating, International Trade",
  ielts: "IELTS",
  languageTests: "Language Proficiency Tests",
  aHundredLessons: "100 lessons",
  ieltsClassIntro:
    "Practical {test name} topics help you build fluency and confidence for your {language} proficiency test.",
  faq: "Q&A",
  questionCn: "",
  classLength: "Q1. How long is the trial class?",
  classInfoAndSuggest:
    "A1: The trial class is 25 minutes long. We recommend beginners take the 30-minute class. For those of higher levels or who have language proficiency tests planned, we suggest you choose the 45-minute class.",
  lessonForm: "Q2: How does the class work?",
  lessonFormInfo:
    "A2: The class will be held through the OnlineClass app. You can take the class on your laptop, tablet, or phone. All classes will be recorded, allowing you to review any time, any place.",
  lessonPrepare: "Q3: Do you provide lesson materials?",
  lessonPrepareInfo:
    "A3: Yes, we do. You can check the materials on your phone before the class. The teacher will also provide feedback after every class. For an optimal experience, we suggest you take the class using a tablet or laptop.",
  support: "Support",
  limitedOffer: "Limited-time offer",
  originalPrice: "Original price",
  bookNow: "Book now!",
  successPurchase: "You have successfully purchased a trial class!",
  trialEndAndGoOn:
    "If you're happy with your teacher, why not buy a monthly/quarterly package to carry on leaning?",
  courseAdvisor: "Course Advisor",
  oneLastStep: "Just one last step...",
  ticketPrice:
    "You can improve your oral {language} for the price of a movie ticket!",
  perPriceAndOrder: "{price}/session - Order Now!",
  noThanks: "No thanks!",
  unpaidAndProceed: "1-on-1 {language} Class trial unpaid. Click to proceed",
  halfPrice: "Get your oral {language} lesson for half price!",
  languageEn: "English",
  languageKo: "Korean",
  languageEsp: "Spanish",
  languageFr: "French",
  languageIt: "Italian",
  languageRu: "Russian",
  languageCn: "Chinese",
  languageJp: "Japanese",
  courseEn: "English",
  courseKo: "Korean",
  courseEsp: "Spanish",
  courseFr: "French",
  courseIt: "Italian",
  courseRu: "Russian",
  courseCn: "Chinese",
  courseJp: "Japanese",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",

  coinSpecialOffer: "HT Coin Top-up Special Offer",
  buySomeAndGetExtra: "Buy some and get extra!",
  balance: "Balance",
  coins: "{number} coins",
  coin: "{number} coin",
  extraCoins: "{number} extra coins",
  continue: "Continue",
  byToppingUpYouAgree: "By topping-up you agree",
  topUpAgreement: "[Top-up agreement]",
  htCoin: "HT Coin",
  scanCodeToLog: "Scan code to log in",
  bindYourHelloTalkAccount:
    "Use the HelloTalk app to scan the code and log in. Bind your HelloTalk account and top-up.",
  itemSelection: "Item selection",
  paymentAmount: "Payment amount",
  topUpSuccessful: "Top-up successful",
  totalCoinsNumber:
    "You have successfully added {numberone} coins and received {numbertwo} extra coins, totaling {numberall} coins.",
  ok: "OK",
  payMethods: "Scan the code with Alipay or WeChat to pay",
  alipay: "Alipay",
  weChatPay: "WeChat Pay",
  copyLinkToPay:
    "Please copy the link and open it with the HelloTalk app to complete the payment.",
  paymentFailed: "Payment failed",
  creditCardPay: "Pay with PayPal or credit card",
  creditCard: "Credit card",
  payssion: {
    // key:value
    purchaseSucceeded: "Purchase successful",
    topUpSuccessful: "Top-up successful",
    paymentFailed: "Payment failed",
    recharge: "Top-up",
    VipRecharge: "VIP top-up",
    rechargeWithCoins: "HT coins top-up",
    oneMonthMember: "One month membership",
    annualFeeMember: "Annual membership",
    oneTimePurchase: "Lifetime membership",
    coins: "{number} HT coins",
    coin: "{number} HT coin",
    extraCoins: "{number} extra HT coins",
    extraCoin: "{number} extra HT coin",
    continue: "Continue",
    byToppingUpYouAgree: "By topping-up you agree to",
    rechargePrompt:
      "Reminder: minors should obtain parental permission or be accompanied by a guardian",
    toppingUpYouAgree: "[Top-up Agreement]",
  },
};
